interface ProConItem {
  proOrCon: 'PRO' | 'CON';
  title: string;
  description: string;
}

export const ProsAndCons = ({ prosAndCons }: { prosAndCons: ProConItem[] }) => {
  if (!prosAndCons || prosAndCons.length === 0) {
    return null;
  }

  const PRO_ICON = 'https://assets.clear.in/cleartax/images/1747376883_pro.svg';
  const CON_ICON = 'https://assets.clear.in/cleartax/images/1747376922_con.svg';

  const pros = prosAndCons.filter((item) => item.proOrCon === 'PRO');
  const cons = prosAndCons.filter((item) => item.proOrCon === 'CON');

  const renderItem = (item) => (
    <div
      key={`${item.proOrCon}-${item.title}`}
      className="lil-flex lil-items-start lil-pb-6"
    >
      <img
        src={item.proOrCon === 'PRO' ? PRO_ICON : CON_ICON}
        className="lil-py-2 lil-pr-6"
        alt={item.proOrCon === 'PRO' ? 'Pro icon' : 'Con icon'}
      />
      <div className="lil-flex lil-flex-col lil-gap-1">
        <p className="lil-font-semibold lil-text-font-500 lil-text-s-20">
          {item.title}
        </p>
        <p className="lil-text-s-20 lil-font-normal lil-text-grey-500">
          {item.description}
        </p>
      </div>
    </div>
  );

  return (
    <div className="lil-mt-8">
      <p className="lil-mb-4 lil-mt-8 lil-font-bold lil-text-font-500 lil-text-s-28 sm:lil-text-s-20 sm:lil-mt-6">
        Pros &amp; Cons
      </p>

      <div className="lil-flex lil-gap-8 sm:lil-flex-col sm:lil-gap-0">
        <div className="lil-w-1/2 sm:lil-w-full">
          {pros.length ? pros.map(renderItem) : null}
        </div>
        <div className="lil-w-1/2 sm:lil-w-full">
          {cons.length ? cons.map(renderItem) : null}
        </div>
      </div>
    </div>
  );
};

export default ProsAndCons;



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/prosAndCons.tsx